import styled from 'styled-components';

export const ShortLine = styled.div`
    height: 3px;
    width: 20px; 
    background-color: ${props => props.red ? props.theme.redColor : props.theme.darkColor};
    margin-bottom: 17px;
`